<template>
  <div class="forensicsAll">
    <div class="forensicsWt">
      <div style="width: 708px;margin: 0px auto;">
        <el-input :placeholder="placeholder" v-model="params.key" class="input-with-select">
          <el-select @change="changeItype" v-model="params.itype" slot="prepend" placeholder="请选择"
            style="width: 124px;">
            <!-- <el-option label="姓名" value="2"></el-option>
            <el-option label="身份证号" value="1"></el-option> -->
            <el-option label="手机号" value="3"></el-option>
          </el-select>
          <el-button slot="append" type="primary" @click="search">{{searchText}}</el-button>
        </el-input>
      </div>

    </div>
    <div class="mainContainer forensics" v-loading="loading">
      <div class="forensics-title">取证查询</div>
      <div v-if="listData.rows.length>0">
        <div v-for="(item,i) in listData.rows" :key="i" class="disFlex between forensics-gglist">
          <div style="font-size: 14px;">
            {{item.username}}取得了{{item.cradname}}
            <i class="el-icon-view" style="color:#0071ba;cursor: pointer;font-weight: 800;" @click="showZs(item)"></i>
          </div>
          <div style="color: #9A9A9A;">{{item.createTime}}</div>
        </div>
      </div>
      <div v-else style="height: 327px;background-color: #fff;text-align: center;">
        <img style="margin: 113px 0 20px;" src="@/assets/images/nodata.png" />
        <div style="font-size: 18px;color: #999999;">暂无数据</div>
      </div>

      <el-pagination style="margin: 15px;text-align: center;" background @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :current-page="params.page" :page-sizes="[10,15,20, 50, 100, 200]"
        :page-size="params.rows" layout="total, sizes, prev, pager, next, jumper" :total="listData.total">
      </el-pagination>
    </div>

    <el-dialog title="验证码" :visible.sync="dialogFormVisible" width="350px">
      <el-form :model="yzmform" ref="yzmform" :rules="rules">
        <el-form-item label="验证码" label-width="80" prop="code">
          <el-input :validate-event="false" v-model="yzmform.code" autocomplete="off" placeholder="请输入验证码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="inputYanzheng">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="证书详情" :visible.sync="dialogVisible" width="800px">
      <div id="firefoxA" style="display:none;"></div>
      <div id="page1" style="padding: 20px;">
        <table class="zscardTable">
          <tr>
            <td colspan="5" style="font-weight: 800;">{{activeCard.cradname}}{{activeCard.des?('【'+activeCard.des+'】'):''}}</td>
          </tr>
          <tr>
            <td>姓名</td>
            <td colspan="2">{{activeCard.username}}</td>
            <td>身份证号</td>
            <td style="width: 200px;">{{activeCard.card}}</td>
          </tr>
          <!--  <tr>
            <td>安全教育培训时间</td>
            <td colspan="4"></td>
          </tr> -->

          <tr>
            <td>培训内容</td>
            <td>指标名称</td>
            <td>完成情况</td>
            <td>培训指标</td>
            <td>培训结果</td>
          </tr>
          <tr>
            <td>视频学习</td>
            <td>完成率</td>
            <td>100%</td>
            <td>100%</td>
            <td>{{activeCard.score}}</td>
          </tr>
          <tr>
            <td colspan="5" style="font-weight: 800;">已完成课程信息</td>
          </tr>
          <tr>
            <td colspan="2" style="font-weight: 800;">课程</td>
            <td style="font-weight: 800;">讲师</td>
            <td style="font-weight: 800;">课时</td>
            <td style="font-weight: 800;">时长</td>
          </tr>
          <tr v-for="(item,i) in listkcs">
            <td colspan="2">{{item.cname}}</td>
            <td>{{item.author}}</td>
            <td>{{item.ks}}</td>
            <td>{{item.xstime}}</td>
          </tr>
        </table>
      </div>
      <span slot="footer" class="dialog-footer" v-if="isXz">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="xzBtn">下载</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  export default {
    name: 'forensics',
    data() {
      var $this = this;
      var validateCode = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('验证码不能为空！'));
        } else if (value.length != 6) {
          callback(new Error('验证码有误，请重新输入！'));
        } else {
          $this.$axios.get('/kt/wz/ktNotify/validPhoneCode.htm?code=' + value, {
            headers: {
              "X-Requested-With": "XMLHttpRequest",
            }
          }).then(res => {
            if (res.data.stat == '1') {
              callback();
            } else {
              callback('验证码有误，请重新输入！');
            }
          })
        }
      };

      return {
        total: 0,
        listData: {
          total: 0,
          rows: []
        },
        // itype(1 是身份证 2 是姓名) key（传的字符串）
        params: {
          rows: 10,
          page: 1,
          itype: '3',
          key: ''
        },
        itype: '3',
        loading: false,
        placeholder: '请输入手机号',
        searchText: '查询',
        searchFlag: 1,
        timerYzm: null,
        second: 60,
        yzmform: {
          code: ''
        },
        dialogFormVisible: false,
        rules: {
          code: [{
            validator: validateCode
          }]
        },
        dialogVisible: false,
        activeCard: {},
        listkcs:[]
      }
    },
    methods: {
      handleSizeChange: function(val) {
        this.$set(this.params, 'rows', val);
        this.getList();
      },
      handleCurrentChange: function(val) {
        this.$set(this.params, 'page', val);
        this.getList();
      },
      // 跳转详情
      toggxq: function(id) {
        sessionStorage.setItem('noticeId', id)
        this.$router.push('/NoticeDetail');
      },
      getList: function(flag, itype) {
        if (this.params.itype && this.params.key) {
          this.loading = true;
          this.searchFlag = 1;
          this.$axios.get('/kt/wz/ktNotify/getzslist.htm?' + this.$qs.stringify(this.params), {
            headers: {
              "X-Requested-With": "XMLHttpRequest",
            }
          }).then(res => {
            var data = res.data;
            this.listData = data;
            this.loading = false;
          })
        }
      },
      // 证书展示
      showZs: function(item) {
        this.activeCard = item;
        this.dialogVisible = true;
        this.$axios.get('/kt/ktCrd/detail.htm?id=' + item.cardid, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          this.activeCard.des=data.data.des;
          this.$axios.get('/kt/ktCurriculum/getNewDetail.htm?id=' + data.data.currid, {
            headers: {
              "X-Requested-With": "XMLHttpRequest",
            }
          }).then(curse => {
            this.listkcs= curse.data.data.listkcs;
          })
        })
      },
      changeItype: function(val) {
        if (val == '3') {
          this.placeholder = "请输入手机号";
          this.searchFlag = 2;
          this.searchText = "获取验证码"
        } else {
          this.placeholder = "请输入姓名/身份证号";
          this.searchFlag = 1;
          this.searchText = "查询";
        };
        if (this.timerYzm) {
          clearInterval(this.timerYzm);
          this.timerYzm = null;
        }
      },
      search: function() {
        var $this = this;
        // 点击查询
        if (this.searchFlag == 1) {
          this.getList()
        } else if (this.searchFlag == 2) {
          // 获取验证码  先判断手机号是否正确
          var phone = this.params.key;
          this.phone = phone;
          if (!phone) {
            this.$message.warning('手机号码不能为空，请重新输入！');
            return;
          } else if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(phone))) {
            this.$message.warning('手机号码输入错误，请重新输入！');
            return;
          };
          // 发送验证码
          this.dialogFormVisible = true;
          this.$axios.post('/kt/wz/ktNotify/sendPCode.htm', this.$qs.stringify({
            phone: phone
          }), {
            headers: {
              "X-Requested-With": "XMLHttpRequest",
            }
          }).then(res => {
            var data = res.data;
            if (data.stat == '1') {
              this.timerYzm = setInterval(function() {
                if ($this.second >= 1) {
                  $this.second--;
                  $this.searchText = $this.second + 's' + '后可重新获取';
                } else {
                  clearInterval($this.timerYzm);
                  $this.timerYzm = null;
                  $this.second = 60;
                  $this.searchText = "获取验证码";
                  $this.searchFlag == 2
                }
              }, 1000);
            }
          });
          this.dialogFormVisible = true;
        } else if (this.searchFlag == 3) {
          // 先验证验证码  验证通过   进行查询
        };
      },
      // 验证码输入的验证码是否正确   输入正确进行查询   输入错误重新弹出
      yanzheng: function(val) {

      },
      inputYanzheng: function() {
        var $this = this;
        this.$refs['yzmform'].validate((valid) => {
          if (valid) {
            clearInterval($this.timerYzm);
            $this.timerYzm = null;
            this.dialogFormVisible = false;
            this.yzmform = {
              code: ''
            };
            this.getList();
          }
        })
      },
    },
    created: function() {
      // this.getList()
    },
    watch: {}
  }
</script>

<style>
  .forensicsWt {
    width: 100%;
    height: 256px;
    background: url(../assets/images/qzwt.png) 0 0 no-repeat;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .forensicsWt .el-input__inner {
    height: 60px !important;
    line-height: 60px !important;
    font-size: 16px !important;
  }

  .forensicsWt .el-input-group__append {
    background: #0071ba;
    color: #fff;
    font-size: 16px !important;
    padding: 0 30px !important;
  }

  .forensics {
    background-color: #fff;
    border-radius: 10px;
    padding: 20px;
  }

  .forensics-title {
    font-size: 20px;
    line-height: 60px;
    text-align: left;
  }

  .forensics-gglist {
    line-height: 60px;
    border-bottom: 1px solid #EFEFEF;
  }

  .forensics .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    border-radius: 50%;
  }

  .forensics .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #0071BA;
  }

  .forensics .el-input-group__append,
  .el-input-group__prepend {
    background-color: #fff !important;
  }

  .zscardTable {
    line-height: 45px;
    font-size: 14px;
  }

  .zscardTable td {
    text-align: center;
    width: 180px;
    border: 1px solid #efefef;
  }
</style>



// WEBPACK FOOTER //
// src/components/Forensics.vue